import { Component, OnInit } from '@angular/core';
import { UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import * as CryptoJS from 'crypto-js';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.css']
})
export class LoginComponent implements OnInit {
  encryptInfo;
  checkdata: any;
  alldata: any[];
  constructor(private router: Router) {
  }

  ngOnInit(): void {
    let alert = '1';
    localStorage.setItem('dataalert', alert);
  }
  hide = true;
  user_log = { username: '', password: '' }

  hashPassword(password: string): string {
    return CryptoJS.SHA256(password).toString();
  }
  isload = false;

  OnLogin(): void {
    let username: string = this.user_log.username//this.form.get('username').value;
    let password: string = this.user_log.password//this.form.get('password').value;
    //console.log('password:', this.hashPassword(password));
    if (username == '' || password == '') { alert('กรุณากรอกข้อมูลให้ครบทุกช่อง !!!'); }
    else {
      // console.log(userinfor);
      let url = 'https://asia-southeast2-brr-farmluck.cloudfunctions.net/dbcps/get_users_ss?user=' + username + '&pass=' + this.hashPassword(password);
      //let url = `https://asia-southeast2-brr-farmluck.cloudfunctions.net/dbcps/select_s_f_w_0?s=supcode,supname,username,zonedata,userlevel,suppic_url&f=[dbCPS].[dbo].[Users]&w=[lockstatus]='N'and[username]='` + username + `'and[password]='` + password + `'`;
      this.isload = true;
      fetch(url)
        .then(res => res.json())
        .then((out: any) => {
          this.isload = false;
          if (out.length > 0) {
            const data = out[0];
            let endata = { username: data.supname, code: data.supcode, alldata: out }
            console.log("endata", endata)
            this.encryptInfo = encodeURIComponent(CryptoJS.AES.encrypt(JSON.stringify(endata), 'bsfdev').toString());
            localStorage.setItem('userdata', this.encryptInfo);
            // console.log('data in login :' ,this.data.alldata)
            localStorage.setItem('supcode', data.supcode);
            localStorage.setItem('supzone', data.zonedata);
            //localStorage.setItem('yearTh', '6667');
            //localStorage.setItem('yearCr', '2324');
            //console.log('data: ', data[0])
            let ulvl = data.userlevel;
            if (ulvl == '5' || ulvl == '6' || ulvl == '7' || ulvl == '9' || ulvl == '10') {
              this.router.navigateByUrl("/finance");
            }
            else {
              this.router.navigateByUrl("/dashboardkpi");
            }
          }
          else { alert('!!!!  ชื่อผู้ใช้ หรือ รหัสผ่านไม่ถูกต้อง กรุณาลองใหม่ !!! '); }
        }).catch(err => { throw err });

    }
  }
}
